import { defineModule } from '@/app/router/defineModule.ts';
import SupportSidebar from '#modules/support/components/SupportSidebar.vue';
import shouldBeAuthenticated from '@/app/router/middleware/shouldBeAuthenticated.js';
import enforceTwoFactor from '@/app/router/middleware/enforceTwoFactor.js';
import ensureUserIsVerified from '@/app/router/middleware/ensureUserIsVerified.js';
import { AppPermissions } from '#modules/auth/constants/permissions.js';

export default defineModule({
    name: 'support',
    routes: [
        {
            path: '/support',
            component: () => import('#modules/support/pages/layout.vue'),
            meta: {
                layout: 'app-sidebar',
                sidebar: SupportSidebar,
                permissions: [AppPermissions.ManageSupportMessages],
                middleware: [shouldBeAuthenticated, enforceTwoFactor, ensureUserIsVerified],
            },
            children: [
                {
                    path: '',
                    name: 'support',
                    component: () => import('#modules/support/pages/index.vue'),
                },
                {
                    path: 'conversations/create',
                    redirect: (to) => {
                        const query = { ...to.query };
                        return { name: 'dashboard', query };
                    },
                },
                {
                    path: 'conversations/:id',
                    name: 'support conversation',
                    component: () => import('#modules/support/pages/show.vue'),
                },
            ],
        },
    ],
});
